<div class="col-12">
    <div class="alert alert-info text-center privacy-policy-container">
      <i class="fas fa-shield-alt fa-lg shield"></i>
      <h5 class="privacy-font">{{ "onboarding.privacy-policy.protected-info1" | translate }}<b>{{ "onboarding.privacy-policy.protected-info2" | translate }}</b>{{ "onboarding.privacy-policy.protected-info3" | translate }}<b>{{ "onboarding.privacy-policy.protected-info4" | translate }}</b></h5>
      <i class="fas fa-info-circle fa-lg info-circle" (click)="displayPrivacyModal = true" style="cursor: pointer"></i>
    </div>
</div>
<!--Display Privacy Modal-->
<p-dialog  header=" " [(visible)]="displayPrivacyModal" [modal]="true" [baseZIndex]="10000" [closable]="true" [breakpoints]="{'640px': '75vw'}" [style]="{ 'width': '40vw' }">
  <app-onboarding-privacy-modal (displayEvent)="displayPrivacyModal=$event"></app-onboarding-privacy-modal>
</p-dialog>